import React, { useState, useEffect } from 'react';
import './index.scss';

import { Modal, Button, Loading, Atag } from 'components/index';
import FormModule from './components/FormModule'
import { getFormInfo } from 'api/Ajax/index';

export default () => {
    /**
     * state
     * 数据列表
     * 表单列表
     * 是否存在报错选项
     * 提交后弹框
     * 提交后弹框文本
     * 组件初始化key
     * 提交的loading
     */
    let [ list, setList] = useState( [] );
    let [ fields, setFields ] = useState( {} );
    let [ canSave, setCanSave ] = useState( {} );
    let [ submitModalShow, setSubmitModalShow ] = useState( false );
    let [ submitCallback, setSubmitCallback ] = useState( '' );
    let [ componentKey, setComponentKey ] = useState( '' );
    let [ spinning, setSpinning ] = useState( false );
    let [ docClass, setDocClass ] = useState( '' );

    /**
     * Func
     * 数据初始化
     * 表单选择
     * 表单提交
     */
    const _initData = (data) => {
        const formList = JSON.parse( data.info.content );
        const formFields = JSON.parse( data.info.fields );
        const formCanSave = {};
        for( let i in formFields){
            formFields[i] = "";
            formCanSave[i] = true;
        }
        formList.map((item)=>{
            if( item.content.must === true ){
                formCanSave[item.id] = false
            }
            if(item.model === "radio"){
                formFields[item.id] = item.content.list[0].value
            }
        })
        setFields( formFields );
        setCanSave( formCanSave );
        setList( JSON.parse(JSON.stringify(formList)) );
    }

    const _afterFormChange = ( id, value, flag ) => {
        fields[id] = value;
        canSave[id] = flag === false ? false : true;

        for( let j = 0 ; j < list.length; j++ ){
            if( list[j].id === id && list[j].must === true ){
                list[j].content.errorShow = !flag;
            }
        }
        setList( list );
        setCanSave( canSave );
        setFields( fields );
    }

    const _submit = ( id ) => {
        /**
         * 表单提交, 检测是否有报错项 并 提交
         */
        let submitFlag = true;
        let listCopy = list;
        for(let i in canSave ){
            if( canSave[i] === false ){
                for( let j = 0 ; j < listCopy.length; j++ ){
                    if( listCopy[j].id === i ){
                        listCopy[j].content.errorShow = true;
                    }
                }
                submitFlag = false;
            }
        }

        if( Boolean(submitFlag) ){
            setSpinning( true )
            getFormInfo( '/submitForm', { form_data: fields }, 'POST' ).then(( data )=>{
                setSubmitModalShow( true )
                if(data.code === 200){
                    setSpinning( false )
                    let tst = '表单提交成功！'
                    for( let i = 0 ; i < list.length; i++ ){
                        if( id === list[i].id ){
                            tst =  list[i].content.toast;
                        }
                    }
                    setSubmitCallback( tst )
                    let listCopy = list;
                    for( let j = 0 ; j < listCopy.length; j++ ){
                        listCopy[j].content.errorShow = false;
                    }
                    JSON.parse(JSON.stringify(listCopy))
                    setComponentKey( new Date().getTime() )
                }else{
                    setSpinning( false )
                    setSubmitCallback( '表单提交失败，请稍后再试！' )
                }
            })
            .catch( ( info )=>{
                setSpinning( false )
                setSubmitCallback( '表单提交失败，请稍后再试！' )
                setSubmitModalShow( true )
                console.log( info )
            })
        }else{
            setList( JSON.parse(JSON.stringify(listCopy)) );
        }
    }

     /**
     * didmount & update & unMount
     * update & unMount 
     */
    useEffect(() => {
        if( window.innerWidth < 640 ){
            setDocClass("isMobile")
        }
        getFormInfo( '/getFormInfo', { }, 'POST' ).then(( data )=>{
            if(data.code === 200){ _initData( data ) }
        })
        .catch( ( info )=>{ })
    },[])

    /**
     * DOM
     */
    return (
        <div>
            <div className={['main', docClass].join(" ")}>
                <Loading
                    config= {{
                        spinning: spinning,
                    }}
                />
                {
                    list.map((item,key)=>{
                        
                        return (
                            <FormModule
                                key = { key }
                                componentKey = { componentKey }
                                id =  { item.id } 
                                model =  { item.model } 
                                content =  { item.content } 
                                afterFormChange = {( id, value, flag )=>{ _afterFormChange( id, value, flag ) }}
                                submit = { ( id )=>{ _submit( id ) } }
                            />
                        )
                    })                
                }
            
                
                <Modal
                    config= {{
                        show: submitModalShow, 
                        closemodal(){ setSubmitModalShow( false ) }// 点击关闭按钮的回调
                    }}
                >
                    <div style={{ lineHeight: "24px" }}>{ submitCallback }</div>
                    <div>
                        <Button
                            config= {{
                                text: '确定',
                                type: 'blue',
                                check(){ setSubmitModalShow( false ) }
                            }}
                        />
                    </div>
                </Modal>
            </div>
            <div className="tagLink">
                <Atag
                    config= {{
                        text: '53KF 提供产品支持', // 文本内容,默认'未知文本'
                        underline: true, // 是否启用下划线, 默认禁用
                        href: 'https://www.53kf.com/?kfcount=form',// 是否启用跳转功能,默认禁用
                        fontSize: 12,// A标签字号,默认12px
                        check(){  },// 点击事件的回调
                    }}
                />
            </div>
        </div>
    )
}


